const investmentsRedirects = {
	routeName: 'investments',
	regExPaths: ['^/pricing$', '^/shopping-experience$'].join('|')
};

export default investmentsRedirects;
